import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {MemberModel, ProjectSettings} from '../../../models/user.model';

type TLoginState = 'login' | 'activate' | 'select_project' | 'selected_project'

export interface ILoginState {
    state: TLoginState,
    userData?: MemberModel,
    token?: string,
    projects?: ProjectSettings[]
}

@Injectable({
    providedIn: 'root'
})
export class GgAuthService {
    public loginStateSub: BehaviorSubject<ILoginState> = new BehaviorSubject({
        state: 'login' as TLoginState,
    })
}